import React, { useEffect } from "react";
import { connect } from "react-redux";
import { withSitecoreContext } from "@sitecore-jss/sitecore-jss-react";
import CarDeliveryTemplate from "../../sections/car-delivery-template";
import BookLocation from "../../react-components/book-location";
import { checkoutProgressAction, setSessionIdAction, setProgressBarDataAction } from "../../redux/actions/actions";
import { selectShowCheckoutProgressBar } from "../../selectors/application";
import { formatProgressBarSteps } from "../../utils/progressBar";

/**
 * There is no integrations made for this component
 * The disgn was changed and this is currently not used
 * You are probably looking for BookingCarDelivery
 */

const CarBookingDelivery = ({ fields, updateProgressBar, user, setProgressBarData, Steps }) => {
  const { backgroundImage } = fields;
  const options = [
    {
      label: "Lynk & Co Club, Gothenburg",
      value: "one",
      tag: "Free",
      description: "5-7 days",
      info: "Welcome to Lynk & Co Club at Magasinsgatan 2. Book your time, come early, hang out and grab a coffee. Feel the vibe."
    },
    {
      label: "Service Point",
      value: "two",
      tag: "€50",
      description: "5-7 days",
      info: "Welcome to Lynk & Co Club at Magasinsgatan 2. Book your time, come early, hang out and grab a coffee. Feel the vibe."
    },
    {
      label: "ThreeBring the car to me (WYW)",
      value: "three",
      tag: "Free",
      description: "5-7 days",
      info: "Welcome to Lynk & Co Club at Magasinsgatan 2. Book your time, come early, hang out and grab a coffee. Feel the vibe."
    },
    {
      label: "Lynk & Co Event",
      value: "four",
      tag: "Free",
      description: "5-7 days",
      info: "Welcome to Lynk & Co Club at Magasinsgatan 2. Book your time, come early, hang out and grab a coffee. Feel the vibe."
    }
  ];
  const carDeliveryBookingDetails = {
    radioAccordion: {
      title: "Locations",
      selectedOption: options[0],
      options,
      button: {
        id: "1",
        buttonText: "Choose date and time",
        width: "auto",
        icon: {
          svg: '<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8-8-8z"/></svg>'
        },
        isDisabled: false,
        callback: event => console.log("Elements/PrimaryButton onClick handler triggered with", event)
      },
      onChange: value => console.log("callback radio button", value)
    },
    type: "car_delivery"
  };

  useEffect(() => {
    const { currentStep, _barSteps } = formatProgressBarSteps(fields?.template?.fields?.progressBar?.fields?.steps);
    setProgressBarData(_barSteps);
    updateProgressBar(currentStep + 1);
    return function cleanUp() {
      setProgressBarData(null);
      updateProgressBar(null);
    };
  }, []);

  return (
    <div className="car-delivery-wrapper">
      <CarDeliveryTemplate fields={fields} backgroundImage={backgroundImage}>
        <BookLocation {...{ ...carDeliveryBookingDetails, fields }} />
      </CarDeliveryTemplate>
    </div>
  );
};
const mapStateToProps = state => ({
  user: state.user,
  sessionId: state.sessionId,
  progressBarIndex: selectShowCheckoutProgressBar(state)
});
const mapDispatchToProps = dispatch => ({
  updateProgressBar: data => dispatch(checkoutProgressAction(data)),
  setSessionId: sessionId => dispatch(setSessionIdAction(sessionId)),
  setProgressBarData: data => dispatch(setProgressBarDataAction(data)),
  dispatch
});
export default connect(mapStateToProps, mapDispatchToProps)(withSitecoreContext()(CarBookingDelivery));
